<template>
<div class="comparison-chart">
<h3 v-html="text.chartTitle"></h3>
<table>
  <thead>
    <tr>
      <td v-html="text.productsTitle"></td>
      <td v-for="item in desiredProducts" :key="item.baselineProductID" v-html="item.ComparisonChartOptions.title">
      </td>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="title" v-html="text.borrowedTitle"></td>
      <td v-for="item in desiredProducts" :key="item.baselineProductID">
        <span v-html="item.ComparisonChartOptions.maxBorrowedAmount ? item.ComparisonChartOptions.maxBorrowedAmount : 'N/A'"></span>
      </td>
    </tr>
    <tr>

      <td class="title" v-html="text.proceedsTitle"></td>
      <td v-for="item in desiredProducts" :key="item.baselineProductID">
        <span v-if="getProductIndex (item.name, products) !==  -1 && products[getProductIndex (item.name, products)].totalAvailableProceeds > 0">
          {{toCurrency(products[getProductIndex (item.name, products)].totalAvailableProceeds)}}
        </span>
        <span v-else>N/A</span>

      </td>
    </tr>
    <tr>
      <td class="title" v-html="text.proceedsAtClosingTitle"></td>
      <td v-for="item in desiredProducts" :key="item.baselineProductID">
        <span v-if="getProductIndex (item.name, products) !== -1 && products[getProductIndex (item.name, products)].totalAvailableDayOne > 0">
          {{toCurrency(products[getProductIndex (item.name, products)].totalAvailableDayOne)}}
        </span>
        <span v-else>N/A</span>
      </td>
    </tr>
    <tr>
      <td class="title" v-html="text.creditGrowthTitle"></td>
      <td v-for="item in desiredProducts" :key="item.baselineProductID">
        <span v-html="item.ComparisonChartOptions.locGrowth ? item.ComparisonChartOptions.locGrowth : 'NA'"></span>
      </td>
    </tr>
    <tr>
      <td class="title" v-html="text.borrowerAgeTitle"></td>
      <td v-for="item in desiredProducts" :key="item.baselineProductID">
        <span v-html="item.ComparisonChartOptions.minAge ? item.ComparisonChartOptions.minAge : 'N/A'"></span>
      </td>
    </tr>
    <tr>
      <td class="title" v-html="text.closingCostsTitle"></td>
      <td :colspan="3" class="note" v-html="text.closingCostsText">
      </td>
    </tr>
  </tbody>
        </table>
        <div class="comparison-details">
          <div v-for="(product, index) in text.products" :key="`product-${index}`">
            <h4 v-html="product.title"></h4>
              <ul class="inline-benefits-list">
                <li v-for="(benefit, i) in product.benefits" :key="`product-${index}-benefit-${i}`" v-html="benefit"></li>
              </ul>
          </div>
          <div class="disclaimer">
            <small class="small" v-html="text.disclaimerText"></small>
          </div>
        </div>
      </div>
</template>

<script>
import { desiredProductArrayIndex } from '../inc/products.js'
import { currencyConversion } from '../inc/helpers.js'
export default {
  name: 'ProductsComparisonChart',
  props: ['products', 'textStrings', 'desiredProducts'],
  data () {
    return {
      text: this.textStrings.comparisonChart
    }
  },
  methods: {
    getProductIndex (productName, products) {
      return desiredProductArrayIndex(productName, products)
    },
    toCurrency (val) {
      return currencyConversion(val)
    }
  },
  mounted () {
  }
}
</script>
